/**
 * Rewrite an HTTP image URL through our same-origin proxy when the page is
 * HTTPS, so browsers don't block (or fail to upgrade) it as mixed content.
 * No-op on HTTP pages and for already-HTTPS / data:/ blob: URLs.
 */
export function safeImg(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (typeof window === "undefined") return url;
  if (window.location.protocol !== "https:") return url;
  if (url.startsWith("https://") || url.startsWith("data:") || url.startsWith("blob:") || url.startsWith("/")) {
    return url;
  }
  if (url.startsWith("http://")) {
    return `/api/img?u=${encodeURIComponent(url)}`;
  }
  return url;
}
